import React, { useReducer, useState } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import '../style/Home.css';
// import instructionVid from "../static/CFIsurgery instructions_LR.m4v";
// import instructionVid from "../static/setup_movie_STCH20.mp4";
import instructionBOX from "../static/FRST_STCH-box_instruction.m4v"
import instructionANASTOMOSIS from "../static/anastomosis_instruction.m4v"
import { Container } from 'react-bootstrap';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import PasswordChange from './PasswordChange';
import { Row, Col } from 'react-bootstrap';
import ReactPlayer from 'react-player';
// import ProjectTimeline from './ProjectTimeline';
// import { Modal } from 'react-bootstrap';

// TODO : Date of birth hidden as date picker not workjing
// TODO : User update profile (name change etc) not set up for submitting

const formReducer = (state, event) => {
    if (event.reset) {
        return {
            dateOfBirth: '',
            firstname: '',
            surname: '',
            email: '',
        }
    }
    return {
        ...state,
        [event.name]: event.value
    }
}




const TraineeProfile = ({ user }) => {

    const [submitting, setSubmitting] = useState(false);
    const [changePassword, setChangePassword] = useState(user.passwordChange);
    // const [dobDate, setDOBDate] = useState(new Date());
    const [formData, setFormData] = useReducer(formReducer, {
        surname: user.surname,
        firstname: user.firstname,
        dateOfBirth: user.dateOfBirth,
        email: user.email,
    });


    const handleSubmit = event => {
        event.preventDefault();
        setSubmitting(true);

        console.log('updating data for ', user.name);
    }

    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        })
    }

    function clickChangePassword() {
        setChangePassword(true);
    };

    return (
        <Container>
            <Row>
                <h3>Profile page for {user.name} </h3>
            </Row>
            {/* {changePassword &&
                <PasswordChange force={user.passwordChange} dbName='trainee'></PasswordChange>
            } */}

            <PasswordChange force={user.passwordChange} dbName='trainee' open={changePassword} onClose={() => setChangePassword(false)}></PasswordChange>

            <Row>
                <Form onSubmit={handleSubmit} disabled={submitting}>
                    <Form.Group >
                        <Form.Label>
                            Email
                            <Form.Control type="textarea" name="email" placeholder={formData.email || ''} readOnly />
                        </Form.Label>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>
                            FirstName
                            <Form.Control type="textarea" name="firstname" onChange={handleChange} value={formData.firstname || ''} readOnly />
                        </Form.Label>
                        <Form.Label >
                            Surname
                            <Form.Control type="textarea" name="surname" onChange={handleChange} value={formData.surname || ''} readOnly />
                        </Form.Label>
                    </Form.Group>
                    {/* <Form.Group className='my-3'>
                    <Form.Label>
                        Date of birth
                        <DatePicker selected={dobDate} onChange={(date:Date) => setDOBDate(date)} />
                        <Form.Control type="date" name="date" pattern="\d{4}-\d{2}-\d{2}" onChange={handleChange} value={formData.dateOfBirth || ''} />
                    </Form.Label>
                </Form.Group> */}
                    <Row>
                        <Col>
                            <Button type="submit" disabled={true}>
                                Submit
                            </Button>
                        </Col>
                        <Col>
                            <Button className='my-4' onClick={clickChangePassword}>
                                Change Password
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>

            <Row className='my-3'>
                <h2>Instructions</h2>
            </Row>
            <Row>
                <ReactPlayer
                    url={instructionBOX}
                    controls={true}
                    playing={false}
                    loop={false}
                ></ReactPlayer>
            </Row>
            <Row>
                <ReactPlayer
                    url={instructionANASTOMOSIS}
                    controls={true}
                    playing={false}
                    loop={false}
                ></ReactPlayer>
            </Row>

            <Row>

                <h2>
                    Welcome to STCH, a training system designed by CFI Surgery
                </h2>

                <p>
                    Your STCH box enables you to complete simulated distal coronary anastomoses, record a video of each procedure on your phone and return the anastomoses to CFI labs for detailed analysis. 
                </p>

                <p>
                    The box contains a foam tray with two recesses designed to securely hold the target vessel block during anastomosis construction. The lid and sleeve work together to create an upright stand for your phone support.
                </p>

                <p>
                    The phone support slides through aligned cut-outs in both the sleeve and lid positioning your phone directly above the anastomosis. When assembled correctly, a target vessel block placed in the foam recess will be directly below your phone and within focal range.
                </p>

                <p>
                    You'll also find four labels each containing two unique identifier codes. These must be attached to the underside of each target block with the code aligned directly beneath the anastomosis above it. These codes are essential for identifying each anastomosis during analysis.
                </p>

                <h3>
                    Proceedure:
                </h3>

                <ul>
                    <li> Place the box in a well-lit location on a sturdy, level table. </li>
                    <li> Remove the tray and lid from the sleeve. </li>
                    <li> Assemble the tray and lid vertically at the back of the tray ensuring the cutouts align. </li>
                    <li> Insert the camera support's footplate through the cutouts with the platform sitting flush against the sleeve. </li>
                    <li> Place your phone on the camera support, positioning the camera lense over the foam recess. </li>
                    <li> Place a target vessel block within the recess. </li>
                    <li> Position your graft conduit close to the target vessel. </li>
                </ul>

                <p>
                    Now you're ready to record. Set your phone to video mode, zoom until the block fills your screen then tap the screen to focus on the target vessel. Start recording and preform your anastomosis. 
                </p>

                <p>
                    Please note: the yellow silicone is highly reflective, and your phone's light can create focusing difficulties. We recommend maximizing external lighting whenever possible.
                </p>
                <p >
                    Use an ophthalmic blade to create an arteriotomy in the target vessel
                </p>

                <p >
                    Carry out an end to side anastomosis.
                </p>

                <p >
                    There is no stipulation about technique or duration as we anticipate that this will change and improve (with practice and feedback) over the duration of the study.
                </p>

                <p >
                    Cut the suture and stop the recording.
                </p>

                <p >
                    If tangles or significant delays occur, please do not stop recording until the attempt is complete.
                </p>

                <p >
                    If the procedure is abandoned and restarted, please only save the final attempt.
                </p>

                <p >
                    Upload the movie to the CFIsurgery database labelling it with unique identifier on the under surface of the target vessel block.
                </p>

                <p >
                    At the end of each phase please place the completed anastomoses in the sleeve boxes and place in courier envelope. The paperwork for freight will be sent to your email
                    please fix this to the envelope and drop with the courier
                </p>

                <p >
                    Your results can be retrieved, within 2 weeks, by accessing your unique profile at CFIsurgery.com.
                </p>




            </Row>

            {/* {user.studies && user.studies.length > 0 &&
                <>
                    <Row className='my-3'>
                        <h2>Timeline {user.studies[0].studyName}</h2>
                    </Row>
                    <Row>
                        <ProjectTimeline studyName={user.studies[0].studyName}></ProjectTimeline>
                    </Row>
                </>
            } */}


        </Container>
    )
}

export default TraineeProfile;